(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec9e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec9e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gz49Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f3244b31b62a48$export$2e2bcd8739ae039);
/* A repeatable Class to allow toggling of load-more classes on specified elements */ class $c0f3244b31b62a48$export$2e2bcd8739ae039 {
    /**
     * Creates an instance of LoadMore.
     *
     * @param {string} [parentClass='.parent'] - The selector for the parent element that contains both the load more and will load elements.
     * @param {string} [loadMoreButton='.load-more'] - The selector for the load more button.
     * @param {string} [itemsToLoad='.will-load'] - The selector for the elements to load.
     * @memberof LoadMore
     */ constructor(parentClass, loadMoreButton = '.load-more', itemsToLoad = '.will-load'){
        this.loadMoreEls = document.querySelectorAll(loadMoreButton);
        this.itemsToLoad = itemsToLoad;
        this.parentClass = parentClass;
        this.bindEvents();
    }
    bindEvents() {
        this.loadMoreEls.forEach((el)=>{
            const parent = el.closest(this.parentClass);
            const willLoadEls = parent.querySelectorAll(this.itemsToLoad);
            el.addEventListener('click', ()=>{
                willLoadEls.forEach((el)=>{
                    el.classList.toggle('is-loaded');
                });
                const loadMoreText = el.textContent;
                el.classList.toggle('hide');
                el.textContent = loadMoreText === 'Show all' ? 'Hide' : 'Show all';
            });
        });
    }
}

});


var $gz49Y = parcelRequire("gz49Y");
new (0, $gz49Y.default)('.block-homepage-news', '.block-homepage-news .load-more');

})();
//# sourceMappingURL=homepage-news.js.map
